import callApi from "@repo/next-shared/utils/api";
import { useQuery } from "@tanstack/react-query";
import { objToQueryParams } from "@repo/next-shared/utils";

export async function getOffersKpi(searchParams: {
  dateFrom: string | Date;
  dateTo: string | Date;
}) {
  return await callApi({
    path: `/kpi/customer/offers?${objToQueryParams(searchParams)}`,
    method: "GET",
  });
}

export function useOffersKpi(queryParams: {
  dateFrom: string | Date;
  dateTo: string | Date;
}): any {
  return useQuery({
    queryKey: ["offersKpi", queryParams],
    queryFn: () => getOffersKpi(queryParams),
  });
}
